import type { InjectionKey, Ref } from 'vue'

/**
 * Injection key for the raw useFetch data ref from SearchPage.
 * Provides direct reactivity to the map composable, bypassing Vue prop
 * update batching that causes markers to not update after modal reopen.
 */
export const SEARCH_DATA_REF_KEY: InjectionKey<Ref<any>> = Symbol('searchDataRef')
